import React, { useMemo, useRef } from "react";
import UserTable from "../../components/Table/User/UserTable";
import ChartCard from "../../layouts/Card/ChartLayout";
import LineChart from "../../components/Charts/LineChart";
import CardChart from "../../components/Cards/CardChart";
import Table from "../../layouts/Table";
import { ItemProps, useFetch, useItems } from "../../hooks/useFetch";
import { IUser } from "../../types/userType";

const UserPage = () => {
	const [result] = useFetch(
		useMemo(() => {
			return {
				metrics: ["ga:users", "ga:newUsers"],
				dimensions: ["ga:date"],
			};
		}, [])
	);

	const item = useRef([]);
	const ops = useMemo<Partial<ItemProps>>(() => {
		return { type: "user", all: true };
	}, []);

	const [users, , loading] = useItems<IUser>(item.current, ops);

	const [city] = useFetch(
		useMemo(() => {
			return {
				metrics: ["ga:users"],
				dimensions: ["ga:city"],
			};
		}, [])
	);
	const [age] = useFetch(
		useMemo(() => {
			return {
				metrics: ["ga:users"],
				dimensions: ["ga:userAgeBracket"],
			};
		}, [])
	);
	const [gender] = useFetch(
		useMemo(() => {
			return {
				metrics: ["ga:users"],
				dimensions: ["ga:userGender"],
			};
		}, [])
	);

	return (
		<div className="grid gap-y-6">
			{" "}
			<div className="grid grid-cols-12 gap-x-6">
				<ChartCard
					className="w-full col-span-8"
					theme="dark"
					title="User Percentage"
				>
					<LineChart theme="dark" data={result} />
				</ChartCard>
				<CardChart type="pie" title="City" className="col-span-4" data={city} />
				{/* <ChartCard
          className="w-full col-span-4"
          subtitle="percentage"
          title="demographic"
        >
          <DoughnutChart data={city} />
        </ChartCard> */}
			</div>
			<Table
				title="New User"
				icon="fas fa-user"
				theme={"light"}
				iconColor="text-orange-500"
				loading={loading}
				to="/dashboard/user/all"
			>
				<UserTable data={users} />
			</Table>
			<div className="grid grid-cols-12 gap-x-6">
				<CardChart
					type="doughnut"
					title="gender"
					className="col-span-3"
					data={age}
				/>
				<CardChart
					type="doughnut"
					title="age"
					className="col-span-3"
					data={gender}
				/>
				<CardChart type="bar" title="vendor / renter" className="col-span-6" />
			</div>
		</div>
	);
};

export default UserPage;
